/* eslint-disable react/no-array-index-key */
import * as React from 'react';

import { LoadingOutlined, Space } from 'farmhub-ui-core';

import { IconWrapper } from 'components';
import { MoreIcon } from 'components/Icon';
import { ExtendedAction } from 'containers/WarehouseOperation/WorkSpace/components';
import { SIZE } from 'utils/constants';

import { Wrapper } from './styles';

export type ActionTable =
  | {
      action?: any;
      icon: any;
      tooltip?: string;
      popover?: React.ReactNode;
      hoverColorIcon?: string;
      isLoading?: boolean;
    }
  | undefined;

interface IconActionTableProps {
  data: ActionTable[];
  extendedAction?: React.ReactNode;
  noteAction?: React.ReactNode;
  amountButton?: number;
  size?: SIZE;
  styles?: any;
  iconLoadingDefault?: JSX.Element;
  iconSize?: 'xs' | 'sm' | 'md' | 'lg';
}

const IconActionTable = ({
  data,
  extendedAction,
  noteAction,
  amountButton = 2,
  size = SIZE.DEFAULT,
  styles,
  iconLoadingDefault = (
    <LoadingOutlined spin className="icon" style={{ fontSize: 18 }} />
  ),
  iconSize = 'sm',
}: IconActionTableProps): JSX.Element => {
  const [showActionList, setShowActionList] = React.useState<any[]>([]);
  const [hiddenActionList, setHiddenActionList] = React.useState<any[]>([]);
  const [waitingShow, setWaitingShow] = React.useState<boolean>(false);

  React.useEffect(() => {
    const initData = () => {
      const countShowItem = noteAction ? 1 : amountButton;

      const newShowActionList = data
        .slice(0, countShowItem)
        .map((item: any) => {
          return {
            ...item,
            icon: item?.isLoading ? iconLoadingDefault : item.icon,
            action: item?.isLoading ? null : item.action,
          };
        });

      const newHiddenActionList = data
        .slice(countShowItem)
        .map((item: any, index: number) => {
          return {
            key: index,
            name: item.tooltip,
            action: item.action,
            icon: item.icon,
            hoverColorIcon: item.hoverColorIcon,
            isLoading: item.isLoading,
            children: item?.children,
          };
        });

      setWaitingShow(newHiddenActionList.some((item: any) => item?.isLoading));
      setShowActionList(newShowActionList);
      setHiddenActionList(newHiddenActionList);
    };

    initData();
  }, [data]);

  return (
    <Wrapper style={styles} width="100%">
      {noteAction && (
        <>
          {noteAction} <Space width={size !== SIZE.SMALL ? 0 : 0} />
        </>
      )}
      {showActionList.map((item: any, index: number) => (
        <IconWrapper
          key={index}
          background="#F1F1F1"
          hoverBackground="rgba(57, 181, 74, 0.2)"
          hoverColorIcon={item.hoverColorIcon}
          icon={item.icon}
          popover={item.popover}
          size={iconSize}
          tooltip={item.tooltip}
          onClick={item.action}
        />
      ))}
      {hiddenActionList.length !== 0 && (
        <ExtendedAction
          component={
            <IconWrapper
              background="#F1F1F1"
              hoverBackground="rgba(57, 181, 74, 0.2)"
              icon={
                waitingShow ? (
                  iconLoadingDefault
                ) : (
                  <MoreIcon
                    height={size === SIZE.SMALL ? 16 : 18}
                    width={size === SIZE.SMALL ? 16 : 18}
                  />
                )
              }
              size={iconSize}
              tooltip="Thêm chức năng"
            />
          }
          data={hiddenActionList}
        />
      )}
      {extendedAction}
    </Wrapper>
  );
};

export default IconActionTable;
